import VueSocialSharing from 'vue-social-sharing'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(VueSocialSharing);
});
